import { Radio, Facebook } from "lucide-react";
import { SOCIAL } from "../../lib/social";
import { useI18n } from "../../lib/i18n";
import { SponsorStrip, NewsletterForm } from "../SponsorStrip";

export const Footer = () => {
  const { t } = useI18n();
  return (
    <>
      <SponsorStrip />
      <section className="border-b border-[color:var(--border)] bg-[color:var(--bg)] py-12">
        <div className="max-w-[1400px] mx-auto px-6 text-center">
          <div className="text-xs uppercase tracking-[0.3em] text-[color:var(--accent)] mb-3">{t("newsletter.eyebrow")}</div>
          <h3 className="font-display text-3xl sm:text-4xl mb-2">{t("newsletter.title")}</h3>
          <p className="text-sm text-[color:var(--text-muted)] mb-6 max-w-xl mx-auto">{t("newsletter.body")}</p>
          <NewsletterForm />
        </div>
      </section>
      <footer className="border-t border-[color:var(--border)] py-10 text-center text-xs uppercase tracking-widest text-[color:var(--text-muted)]">
        <div className="flex items-center justify-center gap-3 mb-3">
          <a
            href={SOCIAL.facebook.url}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-fb-link"
            aria-label={SOCIAL.facebook.label}
            title={SOCIAL.facebook.label}
            className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-[color:var(--border)] hover:border-[#1877F2] hover:text-[#1877F2] transition"
          >
            <Facebook className="w-4 h-4" />
          </a>
        </div>
        <Radio className="inline w-4 h-4 mr-2" /> Fedevo 2.0 · Urban Media · {t("footer.tagline")}
        <div className="mt-2 text-[10px] tracking-[0.2em]">{t("footer.copyright")}</div>
      </footer>
    </>
  );
};
